module.exports = __webpack_public_path__ + "img/cloth_g3_sleeve_14.c498cdf3.svg";